import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if this.canDeleteElement}}\n  <button\n    type=\'button\'\n    class=\'button alert prevent-click-animation\'\n    data-test-toggle-remove\n    ...attributes\n    {{on \'click\' (fn @toggleRemove true)}}\n  >\n    <FaIcon @icon=\'trash-can\' aria-hidden=\'true\' />\n    {{#if this.ui.isNuova}}\n      {{t \'nv.list.delete_forever\'}}\n    {{else}}\n      {{t \'delete\'}}\n    {{/if}}\n  </button>\n{{/if}}\n\n{{#if this.canArchiveElement}}\n  {{! «UI nuova»: «elimina» beside «cestina» read as two deletes — say which one is final }}\n  {{#let\n    (if\n      @item.archivied (t \'restore\') (if this.ui.isNuova (t \'nv.list.move_to_trash\') (t \'trashing\'))\n    )\n    as |archiveText|\n  }}\n    <button\n      type=\'button\'\n      class=\'button prevent-click-animation\'\n      data-test-toggle-remove-2\n      {{on \'click\' (fn @toggleRemove false)}}\n    >\n      {{archiveText}}\n    </button>\n  {{/let}}\n{{/if}}");

var _class, _descriptor, _descriptor2;
let BbDeleteButtonComponent = (_class = class BbDeleteButtonComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "ui", _descriptor2, this);
  }
  get canArchiveElement() {
    const val = this.args.canArchiveElement ?? true;
    return val !== 'false' && val !== false;
  }
  get canDeleteElement() {
    if (!this.args.item) return false;
    let modelName = this.args.item.constructor.modelName;
    if (modelName === 'invoice' && this.args.item.estimate) {
      modelName = 'estimate';
    }
    return this.session.me?.get?.(`role.${modelName}_delete`) ?? false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "ui", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
setComponentTemplate(TEMPLATE, BbDeleteButtonComponent);

export { BbDeleteButtonComponent as default };
//# sourceMappingURL=bb-delete-button.js.map
